export default __webpack_public_path__ + "static/media/75334ae14abdba5a763df56b000187ac.svg";